/* KIWABI JOURNAL: no tracking, safe progressive enhancement. */
(function () {
  'use strict';
  function initShare(root) {
    if (root.dataset.kjReady === '1') return;
    root.dataset.kjReady = '1';
    var field = root.querySelector('[data-kj-url]');
    var status = root.querySelector('[data-kj-status]');
    var fallback = root.querySelector('[data-kj-fallback]');
    var copy = root.querySelector('[data-kj-copy]');
    var nativeButton = root.querySelector('[data-kj-native]');
    if (!field) return;
    function manualCopy() {
      if (fallback) fallback.open = true;
      field.focus(); field.select();
      status.textContent = 'URLを選択しました。コピーして共有してください。';
    }
    if (copy && navigator.clipboard && typeof navigator.clipboard.writeText === 'function' && window.isSecureContext) {
      copy.hidden = false;
      copy.addEventListener('click', function () {
        navigator.clipboard.writeText(field.value).then(function () {
          status.textContent = 'URLをコピーしました。';
        }).catch(manualCopy);
      });
    }
    if (nativeButton && typeof navigator.share === 'function') {
      nativeButton.hidden = false;
      nativeButton.addEventListener('click', function () {
        navigator.share({title: document.title, url: field.value}).catch(function () {});
      });
    }
  }
  function initToc(scope) {
    if (document.documentElement.lang.indexOf('ja') === 0) {
      scope.querySelectorAll('.contents-box-title').forEach(function (el) {
        if (el.textContent.trim().toUpperCase() === 'CONTENTS') el.textContent = '目次';
      });
    }
    if (scope.querySelector('.contents-box a[href^="#"], .kiwabi-toc a[href^="#"], .kiwabi-article-toc a[href^="#"], nav[aria-label*="目次"] a[href^="#"]')) return;
    var heads = Array.from(scope.querySelectorAll('h2')).filter(function (h) {
      return h.textContent.trim() && !h.closest('aside, .kiwabi-product-guide, .kiwabi-sources, [aria-label="関連記事"], .kiwabi-journal-auto-toc');
    });
    if (heads.length < 3 || heads.length > 35) return;
    var nav = document.createElement('nav'); nav.className = 'kiwabi-journal-auto-toc';
    nav.setAttribute('aria-label', '目次');
    var title = document.createElement('p'); title.className = 'kj-toc-title';
    title.textContent = '目次'; nav.appendChild(title);
    var list = document.createElement('ol');
    heads.forEach(function (h,i) {
      if (!h.id) {
        var base = 'kiwabi-journal-heading-' + (i+1), id = base, n = 1;
        while (document.getElementById(id)) id = base + '-' + (++n);
        h.id = id;
      }
      var li=document.createElement('li'), a=document.createElement('a');
      a.href = '#' + encodeURIComponent(h.id);
      a.textContent = h.textContent.trim(); li.appendChild(a); list.appendChild(li);
    });
    nav.appendChild(list); heads[0].parentNode.insertBefore(nav, heads[0]);
  }
  function init(scope) {
    scope.querySelectorAll('[data-kj-share]').forEach(initShare);
    scope.querySelectorAll('.blog__article__content[data-kiwabi-journal]').forEach(function(el) {
      if (el.dataset.kjTocReady === '1') return;
      el.dataset.kjTocReady = '1';
      initToc(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){init(document);}, {once:true});
  } else init(document);
  document.addEventListener('shopify:section:load', function(evt){init(evt.target);});
}());